export const tableClass = "ux-table-data";
//# sourceMappingURL=constants.js.map
